import { render, staticRenderFns } from "./DataApiView.vue?vue&type=template&id=755d6b74&scoped=true"
import script from "./DataApiView.vue?vue&type=script&lang=js"
export * from "./DataApiView.vue?vue&type=script&lang=js"
import style0 from "./DataApiView.vue?vue&type=style&index=0&id=755d6b74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755d6b74",
  null
  
)

export default component.exports